"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./modernizr-custom");
require("./GridLayout.css");
var GridLayout = (function (_super) {
    __extends(GridLayout, _super);
    function GridLayout(props) {
        return _super.call(this, props) || this;
    }
    GridLayout.prototype.render = function () {
        var _a = this.props, tag = _a.tag, height = _a.height, minHeight = _a.minHeight, width = _a.width, minWidth = _a.minWidth, maxWidth = _a.maxWidth, columnDirection = _a.columnDirection, columnDirectionForXs = _a.columnDirectionForXs, columnDirectionForSm = _a.columnDirectionForSm, columnDirectionForMd = _a.columnDirectionForMd, columnDirectionForLg = _a.columnDirectionForLg, columnDirectionForXl = _a.columnDirectionForXl, colsWidth = _a.colsWidth, colsWidthForXs = _a.colsWidthForXs, colsWidthForSm = _a.colsWidthForSm, colsWidthForMd = _a.colsWidthForMd, colsWidthForLg = _a.colsWidthForLg, colsWidthForXl = _a.colsWidthForXl, colMainAxisAlignment = _a.colMainAxisAlignment, colMainAxisAlignmentForXs = _a.colMainAxisAlignmentForXs, colMainAxisAlignmentForSm = _a.colMainAxisAlignmentForSm, colMainAxisAlignmentForMd = _a.colMainAxisAlignmentForMd, colMainAxisAlignmentForLg = _a.colMainAxisAlignmentForLg, colMainAxisAlignmentForXl = _a.colMainAxisAlignmentForXl, colCrossAxisAlignment = _a.colCrossAxisAlignment, colCrossAxisAlignmentForXs = _a.colCrossAxisAlignmentForXs, colCrossAxisAlignmentForSm = _a.colCrossAxisAlignmentForSm, colCrossAxisAlignmentForMd = _a.colCrossAxisAlignmentForMd, colCrossAxisAlignmentForLg = _a.colCrossAxisAlignmentForLg, colCrossAxisAlignmentForXl = _a.colCrossAxisAlignmentForXl, gutterHorizontal = _a.gutterHorizontal, gutterHorizontalForXs = _a.gutterHorizontalForXs, gutterHorizontalForSm = _a.gutterHorizontalForSm, gutterHorizontalForMd = _a.gutterHorizontalForMd, gutterHorizontalForLg = _a.gutterHorizontalForLg, gutterHorizontalForXl = _a.gutterHorizontalForXl, gutterVertical = _a.gutterVertical, gutterVerticalForXs = _a.gutterVerticalForXs, gutterVerticalForSm = _a.gutterVerticalForSm, gutterVerticalForMd = _a.gutterVerticalForMd, gutterVerticalForLg = _a.gutterVerticalForLg, gutterVerticalForXl = _a.gutterVerticalForXl, children = _a.children;
        var cssClasses = ['p-gridlayout'];
        function customizeEnums(en) {
            var cases = {
                'Zero': 'none',
                'Xsmall': 'xs',
                'Small': 'sm',
                'Medium': 'md',
                'Large': 'lg',
                'Xlarge': 'xl',
                'Xlarge2': '2x',
                'Xlarge3': '3x',
                'Xlarge4': '4x',
                'Initial': 'ini',
                'Inherit': 'inh',
                'SpaceAround': 'around',
                'SpaceBetween': 'between'
            };
            return cases[en]
                ? cases[en].toLowerCase()
                : en.toLowerCase();
        }
        function constructClass(prop, prefix, suffix) {
            if (prop && prop !== 'None') {
                var customProp = customizeEnums(prop);
                var className = (prefix && (prefix + '-')) + customProp + (suffix && ('-' + suffix));
                cssClasses.push(className);
            }
        }
        constructClass(columnDirection, '', 'device-none');
        constructClass(columnDirectionForXs, '', 'device-xs');
        constructClass(columnDirectionForSm, '', 'device-sm');
        constructClass(columnDirectionForMd, '', 'device-md');
        constructClass(columnDirectionForLg, '', 'device-lg');
        constructClass(columnDirectionForXl, '', 'device-xl');
        constructClass(colsWidth, 'cols', 'device-none');
        constructClass(colsWidthForXs, 'cols', 'device-xs');
        constructClass(colsWidthForSm, 'cols', 'device-sm');
        constructClass(colsWidthForMd, 'cols', 'device-md');
        constructClass(colsWidthForLg, 'cols', 'device-lg');
        constructClass(colsWidthForXl, 'cols', 'device-xl');
        constructClass(colMainAxisAlignment, '', 'device-none');
        constructClass(colMainAxisAlignmentForXs, '', 'device-xs');
        constructClass(colMainAxisAlignmentForSm, '', 'device-sm');
        constructClass(colMainAxisAlignmentForMd, '', 'device-md');
        constructClass(colMainAxisAlignmentForLg, '', 'device-lg');
        constructClass(colMainAxisAlignmentForXl, '', 'device-xl');
        constructClass(colCrossAxisAlignment, '', 'device-none');
        constructClass(colCrossAxisAlignmentForXs, '', 'device-xs');
        constructClass(colCrossAxisAlignmentForSm, '', 'device-sm');
        constructClass(colCrossAxisAlignmentForMd, '', 'device-md');
        constructClass(colCrossAxisAlignmentForLg, '', 'device-lg');
        constructClass(colCrossAxisAlignmentForXl, '', 'device-xl');
        constructClass(gutterHorizontal, 'gutter-horizontal', 'device-none');
        constructClass(gutterHorizontalForXs, 'gutter-horizontal', 'device-xs');
        constructClass(gutterHorizontalForSm, 'gutter-horizontal', 'device-sm');
        constructClass(gutterHorizontalForMd, 'gutter-horizontal', 'device-md');
        constructClass(gutterHorizontalForLg, 'gutter-horizontal', 'device-lg');
        constructClass(gutterHorizontalForXl, 'gutter-horizontal', 'device-xl');
        constructClass(gutterVertical, 'gutter-vertical', 'device-none');
        constructClass(gutterVerticalForXs, 'gutter-vertical', 'device-xs');
        constructClass(gutterVerticalForSm, 'gutter-vertical', 'device-sm');
        constructClass(gutterVerticalForMd, 'gutter-vertical', 'device-md');
        constructClass(gutterVerticalForLg, 'gutter-vertical', 'device-lg');
        constructClass(gutterVerticalForXl, 'gutter-vertical', 'device-xl');
        var inlineStyles = {};
        inlineStyles["height"] = height;
        inlineStyles["minHeight"] = minHeight;
        inlineStyles["width"] = width;
        inlineStyles["minWidth"] = minWidth;
        inlineStyles["maxWidth"] = maxWidth;
        return (React.createElement("div", { className: cssClasses.join(' '), style: inlineStyles, "data-tag": tag }, children));
    };
    return GridLayout;
}(React.Component));
GridLayout.defaultProps = {
    tag: null,
    height: '',
    minHeight: '',
    width: '',
    minWidth: '',
    maxWidth: '',
    columnDirection: 'None',
    columnDirectionForXs: 'None',
    columnDirectionForSm: 'None',
    columnDirectionForMd: 'None',
    columnDirectionForLg: 'None',
    columnDirectionForXl: 'None',
    colsWidth: 'None',
    colsWidthForXs: 'None',
    colsWidthForSm: 'None',
    colsWidthForMd: 'None',
    colsWidthForLg: 'None',
    colsWidthForXl: 'None',
    colMainAxisAlignment: 'None',
    colMainAxisAlignmentForXs: 'None',
    colMainAxisAlignmentForSm: 'None',
    colMainAxisAlignmentForMd: 'None',
    colMainAxisAlignmentForLg: 'None',
    colMainAxisAlignmentForXl: 'None',
    colCrossAxisAlignment: 'None',
    colCrossAxisAlignmentForXs: 'None',
    colCrossAxisAlignmentForSm: 'None',
    colCrossAxisAlignmentForMd: 'None',
    colCrossAxisAlignmentForLg: 'None',
    colCrossAxisAlignmentForXl: 'None',
    gutterHorizontal: 'None',
    gutterHorizontalForXs: 'None',
    gutterHorizontalForSm: 'None',
    gutterHorizontalForMd: 'None',
    gutterHorizontalForLg: 'None',
    gutterHorizontalForXl: 'None',
    gutterVertical: 'None',
    gutterVerticalForXs: 'None',
    gutterVerticalForSm: 'None',
    gutterVerticalForMd: 'None',
    gutterVerticalForLg: 'None',
    gutterVerticalForXl: 'None'
};
exports.GridLayout = GridLayout;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['layout-controls'])
        csod.engine.controls['layout-controls'] = {};
    csod.engine.controls['layout-controls']['GridLayout'] = GridLayout;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["GridLayout"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-layout-controls/controls/GridLayout/index.js
// module id = 15
// module chunks = 0